/* The website's frame (prototype: .site, .siteMain). Colors are theme tokens only. */
@layer telify {
  /* A phone screen is the Mini App's own: it reads the app's body type (globals.css body), which the website's body does not set. */
  .phone {
    font-size: 16px;
    line-height: 1.5;
  }

  /* The app sets no font on buttons, so a button its CSS does not style keeps the browser's own, as in the Mini App;
   the website's base would give it the page font instead. */
  .phone button {
    font: revert;
  }

  /* The footer sits at the bottom of a short page; the studio's page atmosphere is under everything. */
  .site {
    min-height: calc(100vh - var(--head-h));
    display: flex;
    flex-direction: column;
    background: var(--page-overlay, none), var(--page-image, none), var(--bg-page);
  }

  .main {
    flex: 1;
  }
}
